import SocialLinks from '@/components/footer/SocialLinks';
import Logo from '@/components/icons/Logo';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '@/lib/i18n/useLocale';

const navPaths = [
    { key: 'home', to: '/' },
    // { key: 'services', to: '/services' },
    // { key: 'products', to: '/products/1' },
    { key: 'pricing', to: '/pricing' },
    { key: 'about', to: '/us' },
    { key: 'contact', to: '/contact' },
];

const servicesPaths = [
    { key: 'branding', to: '/services/branding' },
    { key: 'uiux', to: '/services/uiux' },
    { key: 'apps', to: '/services/apps' },
    { key: 'web', to: '/services/web' },
    { key: 'consulting', to: '/services/consulting' },
];

const Footer = () => {
    const { t } = useTranslation();
    const localizedPath = useLocalizedPath();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const social = searchParams.get('social');

    const handleComplaintsClick = () => {
        if (location.pathname.endsWith('/contact')) {
            const complaintsSection = document.getElementById('complaints-section');
            if (complaintsSection) {
                complaintsSection.scrollIntoView({ behavior: 'smooth' });
            }
        } else {
            window.location.href = localizedPath('/contact', {
                hash: 'complaints-section',
                search: social ? `social=${social}` : undefined,
            });
        }
    };

    return (
        <>
            <div className='mainContainer '>
                <div
                    className="hidden lg:block rounded-[24px] px-5"
                    style={{ background: 'linear-gradient(180deg, #145DA0 0%, #0E4272 74.52%)' }}
                >
                    <div className="text-white-blue-50">
                        <div className="pt-10 pb-8 flex flex-row gap-14 justify-between items-start">
                            <div className="flex flex-col items-start justify-center gap-4">
                                <Link to={localizedPath('/')}>
                                    <Logo width="136px" height="[85px]" />
                                </Link>
                                <p className="font-normal text-base leading-[100%] tracking-[0] text-right align-bottom whitespace-nowrap text-footer-copyright">
                                    {t('footer.haveComplaint')}
                                    <span className="underline cursor-pointer" onClick={handleComplaintsClick}>
                                        {t('footer.clickHere')}
                                    </span>
                                </p>
                            </div>

                            {/* Links */}
                            <div className="flex flex-row items-start justify-around w-full">
                                <div className="flex flex-col items-start justify-center gap-4 text-nowrap">
                                    <h3 className="text-[18px] text-footer-text leading-[100%] tracking-normal text-start align-bottom font-bold">
                                        {t('nav.pages')}
                                    </h3>
                                    {navPaths.map(({ key, to }) => (
                                        <Link
                                            key={key}
                                            to={localizedPath(to, { search: social ? `social=${social}` : undefined })}
                                            className="ms-2 font-normal text-[16px] leading-[100%] tracking-normal text-start align-bottom text-footer"
                                        >
                                            {t(`nav.${key}`)}
                                        </Link>
                                    ))}
                                </div>
                                {/* <div className="flex flex-col items-start justify-center gap-6 text-nowrap">
                                <h3 className="font-bold text-[18px] leading-[100%] tracking-normal text-start align-bottom">
                                    {t('nav.features')}
                                </h3>
                                <p className="ms-2 font-normal text-[14px] leading-[100%] tracking-normal text-start align-bottom text-footer">
                                    {t('footer.modernization')}
                                </p>

                                <p className="ms-2 font-normal text-[14px] leading-[100%] tracking-normal text-start align-bottom text-footer mt-2">
                                    {t('footer.reliability')}
                                </p>
                                <p className="ms-2 font-normal text-[14px] leading-[100%] tracking-normal text-start align-bottom text-footer mt-2">
                                    {t('footer.networking')}
                                </p>
                            </div> */}

                                {/* Services */}
                                <div className="flex flex-col items-start justify-center gap-5 text-nowrap">
                                    <h3 className="font-bold text-footer-text text-[18px] leading-[100%] tracking-normal text-start align-bottom">
                                        {t('nav.services')}
                                    </h3>
                                    {servicesPaths.map(({ key, to }) => (
                                        <Link
                                            key={key}
                                            to={localizedPath(to, { search: social ? `social=${social}` : undefined })}
                                            className="ms-2 font-normal text-[14px] leading-[100%] tracking-normal text-start align-bottom text-footer"
                                        >
                                            {t(`${key}`)}
                                        </Link>
                                    ))}
                                </div>

                                {/* Terms and Policies */}
                                <div className="flex flex-col items-start justify-center gap-6 text-nowrap">
                                    <h3 className="font-bold text-footer-text text-[18px] leading-[100%] tracking-normal text-start align-bottom">
                                        {t('nav.termsAndPolicies')}
                                    </h3>
                                    <p className="ms-2 font-normal text-[16px] leading-[100%] tracking-normal text-start align-bottom text-footer">
                                        <Link className="text-footer" to={localizedPath('/terms-and-conditions')}>
                                            {t('nav.termsAndConditions')}
                                        </Link>
                                    </p>
                                    <p className="ms-2 font-normal text-[16px] leading-[100%] tracking-normal text-start align-bottom text-footer">
                                        <Link className="text-footer" to={localizedPath('/privacy-policy')}>
                                            {t('nav.privacyPolicy')}
                                        </Link>
                                    </p>
                                    <p className="ms-2 font-normal text-[16px] leading-[100%] tracking-normal text-start align-bottom text-footer mt-2">
                                        {t('nav.protection')}
                                    </p>
                                </div>

                                {/* Contact Us */}
                                <div className="flex flex-col items-start justify-center gap-6">
                                    <Link
                                        to={localizedPath('/contact', {
                                            search: social ? `social=${social}` : undefined,
                                        })}
                                        className="font-bold text-footer-text text-[18px] leading-[100%] tracking-normal text-start align-bottom"
                                    >
                                        {t('nav.contactUs')}
                                    </Link>
                                    <p className="font-normal text-footer text-[16px] leading-[100%] tracking-[0] text-right align-bottom">
                                        Call: +20 15 50414090
                                    </p>
                                    <p className="font-normal text-footer text-[16px] leading-[100%] tracking-[0] text-right align-bottom">
                                        Email: info@MRNware.com
                                    </p>
                                    <p className="font-normal text-footer text-[16px] leading-[120%] tracking-normal text-right align-bottom lg:max-w-[250px] whitespace-normal">
                                        Cairo, Egypt
                                    </p>
                                    <div className="mt-1">
                                        <SocialLinks variant="inline" className="!gap-x-4" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full border-t border-white-blue-50 opacity-40 mb-4" />
                        <div className="text-center pb-6 text-footer-copyright font-normal text-base">
                            {t('footer.copyright')}
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile */}
            <div
                className="w-full lg:hidden"
                style={{ background: 'linear-gradient(180deg, #145DA0 0%, #0E4272 74.52%)' }}
            >
                <div className="text-white-blue-50">
                    <div className="mainContainer pt-10 pb-8 flex flex-col gap-2 justify-between items-center">
                        <Link to={localizedPath('/')}>
                            <Logo width="72px" height="45px" />
                        </Link>
                        <div className="flex flex-row gap-4 py-1 font-normal text-[12px] leading-[100%] tracking-normal align-bottom text-footer">
                            <p>{t('nav.services')}</p>
                            <span>|</span>
                            <Link to={localizedPath('/us')}>{t('nav.about')}</Link>
                            <span>|</span>
                            <Link to={localizedPath('/contact')}>{t('nav.contactUs')}</Link>
                        </div>
                        <div className="flex flex-row gap-4 py-1 font-normal text-[12px] leading-[100%] tracking-normal align-bottom text-footer">
                            <p>{t('footer.privacyPolicyMobile')}</p>
                            <span>|</span> <p>{t('footer.termsOfService')}</p>
                        </div>
                        <div className="py-[6px]">
                            <SocialLinks />
                        </div>
                    </div>
                    <div className="w-full border-t border-white-blue-50 opacity-40 mb-4" />
                    <div className="text-center pb-6 text-footer-copyright font-normal text-base">{t('footer.copyright')}</div>
                </div>
            </div>
        </>
    );
};
export default Footer;
